var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-loading--progress"},[_c('i',[_vm._v("Loading...")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"yellow darken-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }